import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getLinkedDonationInformation } from "../../../actions/makeAWish"; //TODO
import { Table, TableBody, TableCell, TableContainer, TableRow } from "@material-ui/core";
import Loading from "../../Loading";
import { IAppState } from "../../../types/stores";

type Props = {
    id: string;
    batchNumber: string;
    sequenceNumber: string;
};

const LinkedDonationDataForm: React.FC<Props> = ({ id, batchNumber, sequenceNumber }: Props) => {
    const dispatch = useDispatch();

    const tableCell = {
        fontSize: "16px",
        alignSelf: "center",
        fontFamily: "Roboto",
    };

    const linkedDonationData = useSelector((state: IAppState) => state.makeAWish.linkedDonationData);
    const isDonationsLoading = useSelector((state: IAppState) => state.makeAWish.isDonationsLoading);

    useEffect(() => {
        dispatch(getLinkedDonationInformation(id, batchNumber, sequenceNumber)); // left
    }, [id, batchNumber, sequenceNumber, dispatch]);

    useEffect(() => {
        //create the full list of options
        getLinkedDonationInformation(id, batchNumber, sequenceNumber);
    }, [id, batchNumber, sequenceNumber]);

    return (
        <div className="row m-t">
            <div className="col-sm-16 text-nowrap" style={{ height: "450px", width: "850px" }}>
                {isDonationsLoading ? (
                    <Loading />
                ) : Object.keys(linkedDonationData).length != 0 ? (
                    <TableContainer style={{ maxHeight: "68vh" }}>
                        <Table stickyHeader className={""}>
                            <TableBody>
                                <TableRow>
                                    <TableCell style={{ ...tableCell }}>Ident Number:</TableCell>
                                    <TableCell style={{ ...tableCell }}>{id}</TableCell>
                                    <TableCell style={{ ...tableCell }}>Batch Number:</TableCell>
                                    <TableCell style={{ ...tableCell }}>{batchNumber}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell style={{ ...tableCell }}>Sequence Number:</TableCell>
                                    <TableCell style={{ ...tableCell }}>{sequenceNumber}</TableCell>
                                    <TableCell style={{ ...tableCell }}>Appeal Code:</TableCell>
                                    <TableCell style={{ ...tableCell }}>{linkedDonationData.APPEAL_CODE}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell style={{ ...tableCell }}>Form Code:</TableCell>
                                    <TableCell style={{ ...tableCell }}>{linkedDonationData.FORM_CODE}</TableCell>
                                    <TableCell style={{ ...tableCell }}>Donation Date:</TableCell>
                                    <TableCell style={{ ...tableCell }}>{linkedDonationData.DONATION_DATE}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell style={{ ...tableCell }}>Deposit Date:</TableCell>
                                    <TableCell style={{ ...tableCell }}>{linkedDonationData.DEPOSIT_DATE}</TableCell>
                                    <TableCell style={{ ...tableCell }}>Donation Amount:</TableCell>
                                    <TableCell style={{ ...tableCell }}>{linkedDonationData.DONATION_AMOUNT}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell style={{ ...tableCell }}>Gift Type:</TableCell>
                                    <TableCell style={{ ...tableCell }}>{linkedDonationData.GIFT_TYPE}</TableCell>
                                    <TableCell style={{ ...tableCell }}>Service Center:</TableCell>
                                    <TableCell style={{ ...tableCell }}>{linkedDonationData.SERVICE_CENTER}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell style={{ ...tableCell }}>Zip Code:</TableCell>
                                    <TableCell style={{ ...tableCell }}>{linkedDonationData.ZIP_CODE}</TableCell>
                                    <TableCell style={{ ...tableCell }}>Tax Deductable Amt:</TableCell>
                                    <TableCell style={{ ...tableCell }}>
                                        {linkedDonationData.TAX_DEDUCTIBLE_AMOUNT}
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell style={{ ...tableCell }}>Associated Id:</TableCell>
                                    <TableCell style={{ ...tableCell }}>
                                        {linkedDonationData.ASSOCIATED_IDENT}
                                    </TableCell>
                                    <TableCell style={{ ...tableCell }}>Tribute Type:</TableCell>
                                    <TableCell style={{ ...tableCell }}>{linkedDonationData.TRIBUTE_TYPE}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell style={{ ...tableCell }}>Matching Gift Ind:</TableCell>
                                    <TableCell style={{ ...tableCell }}>
                                        {linkedDonationData.MATCHING_GIFT_IND}
                                    </TableCell>
                                    <TableCell style={{ ...tableCell }}>Ack Flag:</TableCell>
                                    <TableCell style={{ ...tableCell }}>
                                        {linkedDonationData.ACKNOWLEDGMENT_FLAG}
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell style={{ ...tableCell }}>Posted Date:</TableCell>
                                    <TableCell style={{ ...tableCell }}>{linkedDonationData.POSTED_DATE}</TableCell>
                                    <TableCell style={{ ...tableCell }}>Linked Id:</TableCell>
                                    <TableCell style={{ ...tableCell }}>{linkedDonationData.LINKED_IDENT}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell style={{ ...tableCell }}>First Name:</TableCell>
                                    <TableCell style={{ ...tableCell }}>{linkedDonationData.FIRST_NAME}</TableCell>
                                    <TableCell style={{ ...tableCell }}>Surname/Last Name:</TableCell>
                                    <TableCell style={{ ...tableCell }}>{linkedDonationData.SURNAME}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell style={{ ...tableCell }}>Donation Amount:</TableCell>
                                    <TableCell style={{ ...tableCell }}>
                                        {linkedDonationData.H2DONATION_AMOUNT}
                                    </TableCell>
                                    <TableCell style={{ ...tableCell }}>Donation Date:</TableCell>
                                    <TableCell style={{ ...tableCell }}>{linkedDonationData.H2DONATION_DATE}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell style={{ ...tableCell }}>Appeal Code:</TableCell>
                                    <TableCell style={{ ...tableCell }}>{linkedDonationData.H2APPEAL_CODE}</TableCell>
                                    <TableCell style={{ ...tableCell }}>Mailing Description:</TableCell>
                                    <TableCell style={{ ...tableCell }}>
                                        {linkedDonationData.MAILING_DESCRIPTION}
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell style={{ ...tableCell }}>Form Code:</TableCell>
                                    <TableCell style={{ ...tableCell }}>{linkedDonationData.H2FORM_CODE}</TableCell>
                                    <TableCell style={{ ...tableCell }}>Gift Type:</TableCell>
                                    <TableCell style={{ ...tableCell }}>{linkedDonationData.H2GIFT_TYPE}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell style={{ ...tableCell }}>Linked Batch:</TableCell>
                                    <TableCell style={{ ...tableCell }}>{linkedDonationData.LINKED_BATCH}</TableCell>
                                    <TableCell style={{ ...tableCell }}>Linked Seq:</TableCell>
                                    <TableCell style={{ ...tableCell }}>{linkedDonationData.LINKED_SEQ}</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                ) : (
                    <p>{"No Linked Donation Data to display."}</p>
                )}
            </div>
        </div>
    );
};

export default LinkedDonationDataForm;
